import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const DimensionDeleteDialog = ({
  dimensionDeleteDialog,
  setDimensionDeleteDialog,
  handleDelete,
}) => {
  const handleClose = () => {
    setDimensionDeleteDialog(false);
  };
  const handleApprove = () => {
    handleDelete();
    setDimensionDeleteDialog(false);
  };

  return (
    <Dialog
      open={dimensionDeleteDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Kayıtlı ölçünüzü silmek üzeresiniz. Bu işleme devam etmek istediğinize
          emin misiniz?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="iyzi-button-blue" onClick={handleClose}>
          Hayır
        </Button>
        <Button className="iyzi-button-red" onClick={handleApprove} autoFocus>
          Evet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DimensionDeleteDialog;
